export class UrlUtils {

    public static getQueryParam(paramName: any): string | null {
      const urlParams = new URLSearchParams(window.location.search);
      return urlParams.get(paramName);
    }
  }